import { render, staticRenderFns } from "./MenuProcess.vue?vue&type=template&id=cb026faa&scoped=true"
import script from "./MenuProcess.vue?vue&type=script&lang=js"
export * from "./MenuProcess.vue?vue&type=script&lang=js"
import style0 from "./MenuProcess.vue?vue&type=style&index=0&id=cb026faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb026faa",
  null
  
)

export default component.exports